import { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { push } from "connected-react-router"

// Local
import { get } from "library/endpoints";

// Inner
import DefaultView from "./components/Views/DefaultView";
import Basket from "./components/Views/Basket";
import Delivery from "./components/Views/Delivery";
import Payment from "./components/Views/Payment";

// Inner
import * as Styled from './styled';
import RenderWall from "./components/RenderWall";

// Modals
import UserMountsModal from "./components/UserMountsModal";
import CreateEffectModal from "./components/CreateEffectModal";

import { setCurrentHomeView, setGlobalBasket, setGlobalPaymentData, toggleModalEffectCreation, resetUiEnv } from "modules/ui/actions";
import QuotationPayment from "./components/Views/QuotationPayment";
import { isPremium } from "utils";
import SupportParentCategoriesModal from "./components/SupportParentCategoriesModal";

/**
 * Configurator
 * @param {*} props 
 * @returns 
 */
const Configurator = (props) => {
  const [selectedIris, setSelectedIris] = useState([]);
  const [selectedEffect, setSelectedEffect] = useState(null);
  const [effects, setEffects] = useState([]);
  const [userIris, setUserIris] = useState([]);
  const [mountsHistory, setMountsHistory] = useState([]);
  const [selectedMount, setSelectedMount] = useState(null);
  const [selectedSupport, setSelectedSupport] = useState(null);
  const [basket, setBasket] = useState([]); // eslint-disable-line
  const [paymentData, setPaymentData] = useState(null);
  const [countries, setCountries] = useState([]);

  // Modals
  const [displayUserMountsModal, setDisplayUserMountsModal] = useState(false);
  const [displaySupportsModal, setDisplaySupportsModal] = useState(false);

  const setView = (view) => {
    props.setCurrentHomeView(view)
  }

  useEffect(() => { 
    if (!props.auth.token) {
      props.push('/')
    }
    
    if (!isPremium(props.auth.tenant)) {
      return null;
    }
    
    const searchParams = new URLSearchParams(document.location.search)
    if (searchParams.get('entry')) {
      // Reset previous UI
      setDisplayUserMountsModal(true)
    }

    fetchEffects();
    fetchUserIris();
    fetchMountsHistory();
    fetchCountries();

    if (props.ui.globalSelectedMount) {
      setSelectedMount(props.ui.globalSelectedMount)
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    if (paymentData && paymentData.paid === true) {
      setPaymentData(null);
      setSelectedEffect([]);
      setSelectedIris(null);
      setSelectedMount(null);
      setBasket([]);
      setSelectedSupport(null);
      props.push('/orders/success')
    }
  }, [paymentData]) //eslint-disable-line

  const fetchCountries = async () => {
    try {
      const { data } = await get(`/frontend/countries`);
      setCountries(data);
    } catch (error) {
      console.log(error)
    }
  }


  const fetchUserIris = async () => {
    try {
      const { data } = await get(`/frontend/shootings`);
      setUserIris(data);
    } catch (error) {
      console.log(error)
    }
  }

  const fetchEffects = async () => {
    try {
      const { data } = await get(`/frontend/effects`);
      setEffects(data);
    } catch (error) {
      console.log(error)
    }
  }

  const fetchMountsHistory = async () => {
    try {
      const { data } = await get(`/frontend/effect-processing`);
      setMountsHistory(data)
    } catch (error) {
      console.log(error);
    }
  }

  const getIrisUrl = (iris) => {
    return `${process.env.REACT_APP_S3_FILES_URL}tenants/${iris._tenant}/clients/${iris._client}/shootings/${iris._id}/${iris.processed}`;
  }

  const getEffectUrl = (effect) => {
    console.log(effect)
    if (effect._external_ikomiris_id) {
      return `${process.env.REACT_APP_S3_FILES_URL}${effect._external_ikomiris_id}/${effect.picture}`
    }
    return `${process.env.REACT_APP_S3_FILES_URL}${effect._id}/${effect.picture}`;
  }

  const getMountUrl = (output) => {
    return `${process.env.REACT_APP_S3_FILES_URL}${output}`;
  }

  const handleOnAddToBasket = (line) => {
    const entries = [...props.ui.globalBasket];
    entries.push(line);
    props.setGlobalBasket(entries);
  }

  const _renderView = () => {
    switch (props.ui.currentHomeView) {
      case 'basket':
        return (
          <Basket
            setView={setView}
            basket={props.ui.globalBasket}
            setBasket={props.setGlobalBasket}
            selectedMount={selectedMount}
            setDisplaySupportsModal={setDisplaySupportsModal}
            setDisplayUserMountsModal={setDisplayUserMountsModal}
            setPaymentData={props.setGlobalPaymentData}
          />
        )
      
      case 'delivery':
        return (
          <Delivery
            setView={setView}
            basket={props.ui.globalBasket}
            setBasket={props.setGlobalBasket}
            setPaymentData={props.setGlobalPaymentData}
            paymentData={props.ui.globalPaymentData}
            countries={countries}
          />
        )
      case 'payment':
        return (
          <Payment
            setView={setView}
            basket={props.ui.globalBasket}
            setBasket={props.setGlobalBasket}
            setPaymentData={props.setGlobalPaymentData}
            paymentData={props.ui.globalPaymentData}
            countries={countries}
          />
        )
      case 'quotation_payment':
        return (
          <QuotationPayment
            setView={setView}
            basket={props.ui.globalBasket}
            setBasket={props.setGlobalBasket}
            setPaymentData={props.setGlobalPaymentData}
            paymentData={props.ui.globalPaymentData}
            countries={countries}
          />
        )
      default:
        return (
          <DefaultView
            setView={setView}
            selectedIris={selectedIris}
            selectedEffect={selectedEffect}
            selectedMount={selectedMount} 
            selectedSupport={selectedSupport}
            handleAddToBasket={handleOnAddToBasket}
            setDisplayUserMountsModal={setDisplayUserMountsModal}
            setDisplaySupportsModal={setDisplaySupportsModal}
          />
        )
    }
  }

  if (userIris.length === 0) {
    return null;
  }

  const totalGeneratedEffects = mountsHistory.filter((m) => m.generated_by === 'frontend').length

  return (
    <div>
      {
        displayUserMountsModal && (
          <UserMountsModal 
            visible={displayUserMountsModal}
            onOk={() => setDisplayUserMountsModal(false)}
            onCancel={() => setDisplayUserMountsModal(false)}
            mountsHistory={mountsHistory}
            setSelectedMount={setSelectedMount}
            userIris={userIris}
            getMountUrl={getMountUrl}
            setView={setView}
            setDisplayCreateEffectModal={props.toggleModalEffectCreation}
            totalGeneratedEffects={totalGeneratedEffects}
            auth={props.auth}
          />
        )
      }

      {
        displaySupportsModal && (
          <SupportParentCategoriesModal 
            visible={displaySupportsModal}
            onOk={() => setDisplaySupportsModal(false)}
            onCancel={() => setDisplaySupportsModal(false)}
            selectedMount={selectedMount}
            setSelectedSupport={setSelectedSupport}
            selectedSupport={selectedSupport}
            setView={setView}
            handleOnAddToBasket={handleOnAddToBasket}
          />
        )
      }

      {
        props.ui.displayModalEffectCreation && (
          <CreateEffectModal
            visible={props.ui.displayModalEffectCreation}
            onOk={() => props.toggleModalEffectCreation(false)} 
            onCancel={() => props.toggleModalEffectCreation(false)} 
            effects={effects}
            getEffectUrl={getEffectUrl}
            setView={setView}
            userIris={userIris}
            setSelectedMount={setSelectedMount}
            totalGeneratedEffects={totalGeneratedEffects}
            auth={props.auth}
          />
        )
      }

      {
        props.ui.currentHomeView !== 'payment' && (
          <RenderWall 
            selectedIris={userIris[0]}
            getIrisUrl={getIrisUrl}
            setDisplayUserMountsModal={setDisplayUserMountsModal}
            getMountUrl={getMountUrl}
            mountsHistory={mountsHistory}
            selectedMount={selectedMount}
            setView={setView}
            setDisplaySupportsModal={setDisplaySupportsModal}
            effects={effects}
          />
  
        )
      }

      <Styled.HomeOptionsWrapper>
        {
          _renderView()
        }
      </Styled.HomeOptionsWrapper>
    </div>
  )
}

const stateToProps = (state) => ({
  auth: state.auth,
  ui: state.ui,
  push
})

const dispatchToProps = {
  setCurrentHomeView,
  setGlobalBasket,
  setGlobalPaymentData,
  toggleModalEffectCreation,
  resetUiEnv
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Configurator))